import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { fetchPublicAnunciosPaginated, type PublicAnuncio, type PaginatedResult } from "@/lib/public-anuncios";

export type Anuncio = PublicAnuncio;

export const useAnuncios = (filters?: {
  tipo?: string;
  excludeTipos?: string[];
  categoria?: string;
  search?: string;
  includeExpired?: boolean;
  servidores?: string[];
  tiers?: number[];
  minReais?: number;
  maxReais?: number;
  minCoins?: number;
  maxCoins?: number;
  minKk?: number;
  maxKk?: number;
  page?: number;
  pageSize?: number;
  destaqueOnly?: boolean;
  excludeDestaque?: boolean;
  itemNames?: string[];
  apelidos?: string[];
  propostasOnly?: boolean;
  viewerProfileId?: string;
}) => {
  return useQuery({
    queryKey: ["anuncios", filters],
    staleTime: 30_000,
    queryFn: async (): Promise<PaginatedResult> => {
      const result = await fetchPublicAnunciosPaginated({
        tipo: filters?.tipo,
        excludeTipos: filters?.excludeTipos,
        search: filters?.search,
        servidores: filters?.servidores,
        tiers: filters?.tiers,
        minReais: filters?.minReais,
        maxReais: filters?.maxReais,
        minCoins: filters?.minCoins,
        maxCoins: filters?.maxCoins,
        minKk: filters?.minKk,
        maxKk: filters?.maxKk,
        page: filters?.page,
        pageSize: filters?.pageSize,
        destaqueOnly: filters?.destaqueOnly,
        excludeDestaque: filters?.excludeDestaque,
        itemNames: filters?.itemNames,
        apelidos: filters?.apelidos,
        propostasOnly: filters?.propostasOnly,
        includeExpired: filters?.includeExpired,
        viewerProfileId: filters?.viewerProfileId,
      });
      return result;
    },
  });
};

export const useAnuncioConfigs = () => {
  return useQuery({
    queryKey: ["configuracoes_anuncios"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("configuracoes_anuncios")
        .select("*")
        .eq("ativo", true)
        .order("duracao_dias");
      if (error) throw error;
      return data as Array<{
        id: string;
        duracao_dias: number;
        valor_reais: number;
        valor_coins: number;
        percentual_destaque: number;
        ativo: boolean;
      }>;
    },
  });
};

export interface AnuncioDuracaoConfig {
  id: string;
  duracao_dias: number;
  valor_reais: number;
  valor_coins: number;
  percentual_destaque: number;
  ativo: boolean;
  popular?: boolean;
}

export const useAnuncioPersonagemConfigs = () => {
  return useQuery({
    queryKey: ["configuracoes_anuncios_personagens"],
    queryFn: async () => {
      const { data, error } = await (supabase as any)
        .from("configuracoes_anuncios_personagens")
        .select("*")
        .eq("ativo", true)
        .order("duracao_dias");
      if (error) throw error;
      return (data || []) as AnuncioDuracaoConfig[];
    },
  });
};

